/**
* Form JS
* -----------------------------------------------------------------------------
*
* All the JS for the Form component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'form',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const longHeight = 1065;

      if ( $( '.form' ).outerHeight() >= longHeight ) {
        $( '.form__long-svg' ).addClass( 'lg:block' );
        $( '.form__left-svg' ).addClass( 'center' );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'form', COMPONENT );
} )( app );
